<div class="rl">
  @if (duplicates.length) {
  <p class="rl__intro">
    These numbers appear more than once in the file. The count shows how many times each one is
    listed.
  </p>
  <ul class="rl__list">
    @for (duplicate of duplicates; track $index) {
    <li class="duplicate rl__item">
      <span class="number">{{ duplicate.phoneNumber }}</span>
      <span class="rl__meta" aria-hidden="true">× {{ duplicate.count }}</span>
      <span class="bk-sr-only">listed {{ duplicate.count }} times</span>
    </li>
    }
  </ul>
  } @else {
  <div class="noDuplicates rl__empty">
    <span class="bk-sym" aria-hidden="true">content_copy</span>
    <p class="rl__empty-title">No repeated numbers</p>
    <p class="rl__empty-body">Each number appears once in the file.</p>
  </div>
  }
</div>
